// Angular
import { Component, Input } from '@angular/core';
import { IFromTo } from 'libraries/service/resources/booking/interfaces/IGetBookings';

import { IconDefinition, faArrowRight, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";

@Component({
    selector: 'directions',
    template: `
        <div class="directions" [class.inline]="inline" [class.details-closed]="!detailsIsShown">
            <div class="code-container">
                <fa-icon [icon]="iconCircle" *ngIf="detailsIsShown" ></fa-icon>
                <span class="date" *ngIf="begin">({{ begin | dateMoment:'HH:mm' }})</span>
                <strong class="code">{{ from.airport.code }}</strong>
            </div>
            <fa-icon [icon]="inline || !detailsIsShown ? directionIcon : iconArrowDown"
                     [class.fa-arrow-down]="!(inline || !detailsIsShown)"
                     [class.fa-arrow-right]="inline || !detailsIsShown"></fa-icon>
            <div class="code-container">
                <fa-icon [icon]="iconCircle" *ngIf="detailsIsShown"></fa-icon>
                <span class="date" *ngIf="end">({{ end | dateMoment:'HH:mm' }})</span>
                <strong class="code">{{ to.airport.code }}</strong>
            </div>
        </div>
    `,
    styles: [`


        .code-container {
            display: flex;
            align-items: center;
            position: relative;
        }

        .code-container:first-child {
            margin-bottom: 5px;
        }

        .code-container:last-child {
            margin-top: 5px;
        }

        .code {
            font-size: 1.25rem;
        }

        .date {
            margin-left: 5px;
            margin-right: 5px;
            font-size: 0.9rem;
        }

        .details-closed .code-container {
            flex-direction: column-reverse;
            margin: 0;
        }

        .details-closed.directions {
            display: flex;
            align-items: center;
        }

        .fa-arrow-right {
            margin-left: 5px;
        }

        .inline {
            display: flex;
            align-items: center;
        }

        .inline .code-container {
            margin: 0;
        }

        .inline .sector-icon {
            margin-left: 10px;
            margin-right: 7px;
        }
    `]
})
export class DirectionsComponent {
    @Input()
    public from: IFromTo;

    @Input()
    public to: IFromTo;

    @Input()
    public begin: string;

    @Input()
    public end: string;

    @Input()
    public detailsIsShown: boolean;

    @Input()
    public inline: boolean = false;

    @Input()
    public directionIcon: IconDefinition = faArrowRight;

    public iconArrowDown: IconDefinition = faArrowDown;
    public iconCircle: IconDefinition = faCircle;
}
